export default __webpack_public_path__ + "static/media/legacy.108aa9d7.webp";